import { Controller, type UseFormReturn } from 'react-hook-form';
import { SectionCard } from '@/components/common/SectionCard';
import { TextField } from '@/components/forms/TextField';
import { TextareaField } from '@/components/forms/TextareaField';
import type { CreateStartupFormValues } from '../../../schema';
import {
  FIELD_LABELS,
  FIELD_PLACEHOLDERS,
  MAX_DESCRIPTION_LENGTH,
  SECTION_TITLES,
} from '../../../constants';
import { NUMERIC_INPUT_MAX_DIGITS_COUNT } from '@/lib/constants/numeric-input';

interface SectionProps {
  form: UseFormReturn<CreateStartupFormValues>;
}

/** Step 1 "Company Details" card (Figma 287:3098). */
export function BasicDetails({ form }: SectionProps) {
  const {
    register,
    control,
    formState: { errors },
  } = form;

  return (
    <SectionCard title={SECTION_TITLES.BASIC_DETAILS}>
      <div className="flex flex-col gap-5">
        <div className="grid gap-5 sm:grid-cols-2">
          <TextField
            {...register('companyName')}
            label={FIELD_LABELS.companyName}
            required
            placeholder={FIELD_PLACEHOLDERS.companyName}
            error={errors.companyName?.message}
          />
          <TextField
            {...register('companyWebsiteUrl')}
            label={FIELD_LABELS.companyWebsiteUrl}
            type="url"
            placeholder={FIELD_PLACEHOLDERS.companyWebsiteUrl}
            error={errors.companyWebsiteUrl?.message}
          />
          <Controller
            control={control}
            name="employeeCount"
            render={({ field }) => (
              <TextField
                {...field}
                numeric
                maxDigits={NUMERIC_INPUT_MAX_DIGITS_COUNT}
                label={FIELD_LABELS.employeeCount}
                placeholder={FIELD_PLACEHOLDERS.employeeCount}
                error={errors.employeeCount?.message}
              />
            )}
          />
          <TextField
            {...register('companyLinkedinUrl')}
            label={FIELD_LABELS.companyLinkedinUrl}
            type="url"
            placeholder={FIELD_PLACEHOLDERS.companyLinkedinUrl}
            error={errors.companyLinkedinUrl?.message}
          />
        </div>
        <TextareaField
          {...register('briefDescription')}
          label={FIELD_LABELS.briefDescription}
          rows={4}
          maxLength={MAX_DESCRIPTION_LENGTH}
          showCount
          placeholder={FIELD_PLACEHOLDERS.briefDescription}
          error={errors.briefDescription?.message}
        />
      </div>
    </SectionCard>
  );
}
